import $ from 'jquery';
import AjaxRequest from "../modules/ajax-request";

class AccountSavedArticles {
    constructor(element) {
        this.a = element;
        this.id = $(this.a).data("id");
        this.typeId = $(this.a).data("type");
        this.url = $(this.a).data("href");

        this.clearData();
        this.bindEvents();
    }
    clearData() {
        $(this.a).removeAttr("data-id");
        $(this.a).removeAttr("data-type");
        $(this.a).removeAttr("data-href");
        $(this.a).removeAttr("data-item-list");
    }
    bindEvents() {
        var _thisItem = this;
        $(this.a).on("click", function (event) {
            _thisItem.removeItem(event);
        });
    }
    removeItem(event) {
        event.preventDefault();
        var $this = $(this.a);
        var ajaxRequest = new AjaxRequest({
            elementToAddLoading: $this,
            successCallback: function (response, statusCode, xhr) {
                if (xhr.status === 200) {
                    $this.parents('.c-saved-list__item').remove();
                }
            }
        });
        ajaxRequest.makeCall(this.url, {
            id: this.id,
            type_id: this.typeId
        });
    }
}

var AccountSavedArticless = function (element) {
    this._div = element;
    var _url = $(this._div).data('url');

    $(this._div).removeAttr('data-url');

    var _this = this._div;
    var _ajaxRequest = new AjaxRequest({
        successCallback: function (response) {
            $(_this).append(response);
            $('[data-item-list]').each(function () {
                new AccountSavedArticles(this);
            });
        }
    });
    _ajaxRequest.makeCall(_url);

    $(this._div).on('click', '[data-id="ajax_paginator"]', function () {
        var _span = $(this).find('[data-id="span"]');
        var _url = $(_span).data("href");
        var _this = this;

        var _ajaxRequest = new AjaxRequest({
            successCallback: function (response) {
                $(_this).removeClass("loading");
                $(_this).replaceWith(response);
                $('[data-item-list]').each(function () {
                    new AccountSavedArticles(this);
                });
            }
        });

        $(_this).addClass("loading");
        _ajaxRequest.makeCall(_url);
    });
};

export default AccountSavedArticless;